import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24fe61b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-zoom" }
const _hoisted_2 = { class: "image-zoom-actions" }
const _hoisted_3 = { class: "image-zoom-actions-top" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["aria-label"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-compress-arrows-alt" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "image-zoom-actions-bottom" }
const _hoisted_14 = ["aria-label"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-up" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["aria-label"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["aria-label"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-right" }, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = ["aria-label"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-down" }, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = ["aria-label"]
const _hoisted_27 = ["width", "height"]
const _hoisted_28 = {
  class: "overview",
  ref: "canvasOverview",
  width: "250",
  height: "250"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          "data-testid-zoom-in": "",
          class: "btn gossamer p-4 m-2",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.zoomIn && _ctx.zoomIn(...args))),
          "aria-label": _ctx.$t('aria.image.zoom-in')
        }, _hoisted_6, 8, _hoisted_4),
        _createElementVNode("button", {
          "data-testid-zoom-out": "",
          class: "btn gossamer p-4 m-2",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.zoomOut && _ctx.zoomOut(...args))),
          "aria-label": _ctx.$t('aria.image.zoom-out')
        }, _hoisted_9, 8, _hoisted_7),
        _createElementVNode("button", {
          "data-testid-clear": "",
          class: "btn gossamer p-4 m-2",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args))),
          "aria-label": _ctx.$t('aria.image.reset')
        }, _hoisted_12, 8, _hoisted_10)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("button", {
          "data-testid-up": "",
          class: "btn gossamer p-4 m-2",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.move(0, 25))),
          "aria-label": _ctx.$t('aria.image.move-to-top')
        }, _hoisted_16, 8, _hoisted_14),
        _createElementVNode("button", {
          "data-testid-left": "",
          class: "btn gossamer p-4 m-2",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.move(25, 0))),
          "aria-label": _ctx.$t('aria.image.move-to-left')
        }, _hoisted_19, 8, _hoisted_17),
        _createElementVNode("button", {
          "data-testid-right": "",
          class: "btn gossamer p-4 m-2",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.move(-25, 0))),
          "aria-label": _ctx.$t('aria.image.move-to-right')
        }, _hoisted_22, 8, _hoisted_20),
        _createElementVNode("button", {
          "data-testid-down": "",
          class: "btn gossamer p-4 m-2",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.move(0, -25))),
          "aria-label": _ctx.$t('aria.image.move-to-bottom')
        }, _hoisted_25, 8, _hoisted_23)
      ])
    ]),
    _createElementVNode("section", {
      class: "image-zoom-canvas",
      "aria-label": _ctx.$t('aria.image.label')
    }, [
      _createElementVNode("canvas", {
        class: "center",
        ref: "canvas",
        width: _ctx.width,
        height: _ctx.height,
        onMousedown: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onMouseDown && _ctx.onMouseDown(...args))),
        onMousemove: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onMouseMove && _ctx.onMouseMove(...args))),
        onMouseup: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onMouseUp && _ctx.onMouseUp(...args))),
        onMousewheel: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onMouseWheel && _ctx.onMouseWheel(...args))),
        onWheel: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onMouseWheel && _ctx.onMouseWheel(...args))),
        onTouchstart: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onTouchDown && _ctx.onTouchDown(...args))),
        onTouchmove: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onTouchMove && _ctx.onTouchMove(...args))),
        onTouchend: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onTouchUp && _ctx.onTouchUp(...args)))
      }, null, 40, _hoisted_27),
      _createElementVNode("canvas", _hoisted_28, null, 512)
    ], 8, _hoisted_26)
  ]))
}